import React from "react";
import PropTypes from "prop-types";

import {
  Container,
  FlixxCoin
} from './styles'
import useLocation from "hooks/useLocation";
import { formatAmount } from "utils/amounts";
import { useGetBalance } from "api/user";
import { GAHandler } from "utils/GA";

const FlixxBalance = () => {

  const { data: amount } = useGetBalance()
  const { isPlay } = useLocation()

  const handleClick = () => {
    GAHandler('ui_balance');
  }

  return (
    <Container
      to='/flixx'
      onClick={handleClick}
      $isDark={isPlay}
    >
      <FlixxCoin />
      <span>{formatAmount(amount)}</span>
    </Container>
  );
};

FlixxBalance.propTypes = {
  onClick: PropTypes.func,
};

export default FlixxBalance;
